import { render, staticRenderFns } from "./DteDetailTableSection.vue?vue&type=template&id=39fb6228"
import script from "./DteDetailTableSection.vue?vue&type=script&lang=js"
export * from "./DteDetailTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports